// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"file-csv"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20 10V7L15 2H4V22H20M14 2V8H20","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M20 13L20 16.4369C20 16.601 19.9596 16.7626 19.8824 16.9074L18.5234 19H18.5L17.1176 16.9074C17.0404 16.7626 17 16.601 17 16.4369V13M14.25 13H12.5C12.2239 13 12 13.2239 12 13.5V15.5C12 15.7761 12.2239 16 12.5 16H14C14.2761 16 14.5 16.2239 14.5 16.5V18.5C14.5 18.7761 14.2761 19 14 19H12.25M9.25129 13H7.5C7.22386 13 7 13.2239 7 13.5V18.5C7 18.7761 7.22386 19 7.5 19H9.25129","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-file-csv')
export default class FileCsvIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-csv',
    }
  }
}
